import { client, api } from "@/client";
import { StorageSerializers, useStorage } from "@vueuse/core";
import { defineStore, acceptHMRUpdate } from "pinia";
import { Client } from "typesense";

export const useFolderStructureStore = defineStore("folderstruct", {
  state: () => ({
    loading: false,
    totalFile: 0,
    convertedStructure: [],
    rawStructure: [
      {
        name: "GovTECH_20180620102030",
        path: "/GovTECH_20180620102030",
        type: "directory",
      },
      {
        name: "Folder1",
        path: "/GovTECH_20180620102030/Folder1",
        type: "directory",
      },
      {
        name: "Folder2",
        path: "/GovTECH_20180620102030/Folder2",
        type: "directory",
      },
      {
        name: "Record1",
        path: "/GovTECH_20180620102030/Folder1/Record1",
        type: "directory",
      },
      {
        name: "Record2",
        path: "/GovTECH_20180620102030/Folder1/Record2",
        type: "directory",
      },
      {
        name: "Converted",
        path: "/GovTECH_20180620102030/Folder1/Record1/Converted",
        type: "directory",
      },
      {
        name: "Native",
        path: "/GovTECH_20180620102030/Folder1/Record1/Native",
        type: "directory",
      },
      {
        name: "Hello testing 123.pdf",
        path: "/GovTECH_20180620102030/Folder1/Record1/Converted/Hello testing 123.pdf",
        type: "file",
      },
    ],
    fileList: [] as any,
    searchKey: null as api.KeysResponseBody | null,
    typesenseheader: "" as string | undefined,
    array: [] as any,
    folder: [] as any,
    uuidArray: [] as any,
  }),
  getters: {},
  actions: {
    async fetchTypesenseFile(searchParameters) {
      this.$reset;
      this.loading = true;

      const key = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      const inOneMinute = Math.floor(Date.now() / 1000) + 60;
      if (!key.value || key.value.expiresAt < inOneMinute) {
        key.value = await client.search.searchKeys();
      }
      this.searchKey = key.value;
      this.typesenseheader = this.searchKey?.packagesKey;

      const x = new Client({
        nodes: [
          {
            host: import.meta.env.VITE_TYPESENSE_ADDR,
            port: import.meta.env.VITE_TYPESENSE_PORT,
            path: import.meta.env.VITE_TYPESENSE_NAME,
            protocol: import.meta.env.VITE_PROTOCOL,
          },
        ],
        apiKey: String(this.typesenseheader),
        connectionTimeoutSeconds: 20,
      });

      x.collections("secure-zone-files")
        .documents()
        .search(searchParameters)
        .then((result: any) => {
          this.reset();
          let element2: any = {};
          for (let z = 0; z < result.hits.length; z++) {
            var type="";
            if(result.hits[z].document.name.includes("objects/")){
              type ="AIP_";
              var new_filename = "AIP_"+result.hits[z].document.package_uuid+"/data/"+result.hits[z].document.name;
            }else{
              type ="DIP_";
               new_filename = "DIP_"+result.hits[z].document.package_uuid+"/"+result.hits[z].document.name;
            }

            // var new_filename = result.hits[z].document.name;
            // console.log("11",new_filename);
            
            // const element = result.hits[z].document.name;
            // this is too show the folder structure
            this.fileList.push(new_filename);
            this.fileList.sort();
            //element 2 is for when click go to the file page
            element2 = {
              name: new_filename,
              uuid: result.hits[z].document.uuid,
            };
            this.uuidArray.push(element2);
          }
        })
        .finally(() => {
          let result = this.fileList.reduce(
            (arr, path) => this.addPath(path, path.split("/"), arr),
            []
          );

          this.convertedStructure = result;
          // this.sortFolderData(this.rawStructure);
        });
      // .finally(() => {
      //   let array: any = [];
      //   let element2: any = {};
      //   let folder: any = [];
      //   for (let i = 0; i < this.fileList.length; i++) {
      //     let currentPath = this.fileList[i];
      //     let splitPath = currentPath.split("/");
      //     let countPath = currentPath.split("/").length;
      //     for (let y = 0; y < countPath; y++) {
      //       let qwe = splitPath.join("/");
      //       let fileName = splitPath.pop();
      //       if (fileName.includes(".")) {
      //         element2 = {
      //           name: fileName,
      //           path: qwe,
      //           type: "file",
      //         };
      //       } else {
      //         element2 = {
      //           name: fileName,
      //           path: qwe,
      //           type: "directory",
      //         };
      //       }
      //       array.push(element2);
      //     }
      //     // throw new Error("my error message");
      //   }
      //   var folder2 = array.filter((element2) => {
      //     const isDuplicate = folder.includes(element2.path);
      //     if (!isDuplicate) {
      //       folder.push(element2.path);
      //       return true;
      //     }
      //     return false;
      //   });
      //   this.sortFolderData(this.rawStructure);
      //   this.loading = false;
      // });
    },
    addPath(path, pathcomponents, arr) {
      let component = pathcomponents.shift();
      let comp = arr.find((item) => item.label === component);
      if (!comp) {
        if (component.includes(".") && !component.includes("---")) {
          comp = {
            id: "customization-class-rootNode",
            label: component,
            style: "file",
            path: path,
          };
        } else {
          comp = {
            id: "customization-class-rootNode",
            label: component,
            style: "directory",
          };
        }

        arr.push(comp);
      }
      if (pathcomponents.length) {
        this.addPath(
          path,
          pathcomponents,
          comp.children || (comp.children = [])
        );
      }
      return arr;
    },
    // sortFolderData(folderStructure) {
    //   let result: any = [];
    //   let level = { result };
    //   let fullPath = "";
    //   for (let index = 0; index < folderStructure.length; index++) {
    //     fullPath = folderStructure[index].path;
    //     // for (let index = 1; index < folderStructure.length; index++) {
    //     //   fullPath =
    //     //     folderStructure[index].path + "/" + folderStructure[index].name;
    //     if (fullPath.substring(0, 1) === "/") {
    //       fullPath = fullPath.substring(1);
    //     }
    //     fullPath.split("/").reduce((accumulator: any, currentValue: string) => {
    //       // console.log("final", index, "xxxxx", accumulator[currentValue]);
    //       // throw new Error("my error message");
    //       if (!accumulator[currentValue]) {
    //         if (currentValue.includes(".")) {
    //           this.totalFile++;
    //         }
    //         accumulator[currentValue] = { result: [] };
    //         accumulator.result.push({
    //           id: "customization-class-rootNode",
    //           label: currentValue,
    //           children: accumulator[currentValue].result,
    //           style: folderStructure[index].type,
    //         });
    //       }
    //       return accumulator[currentValue];
    //     }, level);
    //     this.convertedStructure = result;
    //     console.log(this.convertedStructure);
    //   }
    // },

    reject() {},
    reset() {
      this.convertedStructure = [];
      this.rawStructure = [];
      this.fileList = [];
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useFolderStructureStore, import.meta.hot)
  );
}
